import {IDevice} from '@interfaces/devices';
import {DeviceProofMode} from '@shared/device-proof';

export class UpdateDeviceProofMode {
  static readonly type = '[Devices] Update proof mode';

  constructor(public guid: string, public mode: DeviceProofMode) {}
}

export class FetchDevices {
  static readonly type = '[Devices] Fetch devices';

  constructor(public params?: {
    order?: string,
    noGroup?: 1 | 0,
    onSchedule?: 1 | 0
  }) {
  }
}

export class CleanStoredDevices {
  static readonly type = '[Devices] Clean stored devices';
}

export class ChangeDevicesMenuStatus {
  static readonly type = '[Device] Change device mobile menu status';

  constructor(public status: boolean) {
  }
}

export class GetAmountOfAllSystemDevices {
  static readonly type = '[Devices] Get amount of all system devices';
}

export class ChangeCurrentDevicesPage {
  static readonly type = '[Devices] Change current page param';

  constructor(public currentPage: number) {
  }
}

export class SetCurrentDevicesPage {
  static readonly type = '[Devices] Set current page param';

  constructor(public currentPage: number) {
  }
}

export class SearchDevices {
  static readonly type = '[Devices] Change search devices param';

  constructor(public searchParam: string) {
  }
}

export class SetSearchDevicesParam {
  static readonly type = '[Devices] Set search devices param';

  constructor(public searchParam: string) {
  }
}

export class CleanSearchDevicesParam {
  static readonly type = '[Devices] Clean search devices param';
}

export class CleanCurrentDevicesPageParam {
  static readonly type = '[Devices] Clean devices page param';
}

export class ChangeDevicesPerPage {
  static readonly type = '[Devices] Change devices per page';

  constructor(public devicesPerPage: number) {
  }
}

export class SetDevicesPerPage {
  static readonly type = '[Devices] Set devices per page';

  constructor(public devicesPerPage: number) {
  }
}

export class DeleteDevice {
  static readonly type = '[Devices] Delete device';

  constructor(public id: number) {
  }
}

export class DeleteDevicesFromGroup {
  static readonly type = '[Devices] Delete devices from group';

  constructor(public groupId: number, public deviceIds: number[]) {
  }
}

export class CreateDevice {
  static readonly type = '[Devices] Create device';

  constructor(public device: IDevice) {
  }
}

export class GetDevicesInfo {
  static readonly type = '[Devices] Get devices info';

  constructor(public guids: string[]) {
  }
}

export class GetUnapprovedDevices {
  static readonly type = '[Unapproved] Get unapproved devices';
}

export class GetUngroupedDevices {
  static readonly type = '[Devices] Get ungrouped devices';

  constructor(public params: { limit: number, skip?: number, search?: string, order?: string }){}
}

export class GetDevicesWithoutGroupTotal {
  static readonly type = '[Devices] Get devices without group total';
}

export class SetSelectedDevice {
  static readonly type = '[Devices] Set selected device';

  constructor(public id: number) {
  }
}

export class EditDevice {
  static readonly type = '[Devices] Edit device';

  constructor(public device: IDevice) {
  }
}

export class GetScreenshot {
  static readonly type = '[Devices] Get screenshot old';

  constructor(public deviceGuid: string) {
  }
}

export class GetScreenshotV2 {
  static readonly type = '[Devices] Get screenshot';

  constructor(public deviceGuid: string) {
  }
}

export class GetCSVReport {
  static readonly type = '[Devices] Get CSV report';

  constructor(public devices: IDevice[]) {
  }
}

export class AddDevicesToGroup {
  static readonly type = '[Devices] Add devices to group';

  constructor(public groupId: number,
              public devicesId: number[]) {
  }
}

export class ToggleDeviceInfo {
  static readonly type = '[Devices] Toggle devices info';

  constructor(public guid: string,
              public status: boolean) {
  }
}

export class RestartDevice {
  static readonly type = '[Devices] Restart device';

  constructor(public guid: string) {
  }
}

export class SetDeviceDefaultPerPage {
  static readonly type = '[Devices] Set default per page value';
}

export class ChangeDevicePageWithoutUrlParams {
  static readonly type = '[Devices] Change device current page without saving into url params';

  constructor(public currentPage: number) {
  }
}

export class ChangeDeviceSearchParam {
  static readonly type = '[Devices] Change device search param';

  constructor(public searchParam: string) {
  }
}

export class CleanDevices {
  static readonly type = '[Devices] Clean Devices';
}


export class CleanSelectedDevices {
  static readonly type = '[Devices] Clean selected devices';
}

export class SortDevices {
  static readonly type = '[Devices] Sort devices';

  constructor(public param: string) {
  }
}

export class SetDefaultSortParam {
  static readonly type = '[Devices] Set default sort param';
}
